const DimensionTypeEnum = {
  SingleSelect: 0,
  MultiSelect: 1,
  Rating: 2,
  Text: 3
}

export default DimensionTypeEnum
